/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'info-icon': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M6 0C2.684 0 0 2.684 0 6s2.684 6 6 6 6-2.684 6-6-2.684-6-6-6zm0 11.063A5.06 5.06 0 01.937 6 5.06 5.06 0 016 .937 5.06 5.06 0 0111.063 6 5.06 5.06 0 016 11.063z" _fill="#000" fill-opacity=".4"/><path pid="1" d="M6 5.023a.469.469 0 00-.469.47V8.51a.469.469 0 10.938 0V5.492A.469.469 0 006 5.023zM6 4.45a.633.633 0 100-1.266.633.633 0 000 1.265z" _fill="#000" fill-opacity=".4"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/info-icon.js